export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/IL-c1b19e2e2bd5fbcaa9dc6734d3b9bb8f.png";